import { Component, Output,Input, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-navbar',
    templateUrl: './college-form-navbar.component.html',
    styleUrls: ['./college-form-navbar.component.scss']
})
export class CollegeFormNavbarComponent {
    @Output() tabChange = new EventEmitter<string>();
    @Input() activeTab: string = 'about';
    public navLinks = [
        { id: 'about', label: 'About Us' },
        { id: 'location', label: 'Location' },
        { id: 'courses', label: 'Courses' },
        { id: 'amenities', label: 'Amenities' },
        { id: 'profile', label: 'Profile' },
        { id: 'collegeinfo', label: 'College Info' },
        { id: 'approvals', label: 'Approvals' },
        { id: 'admission', label: 'Admission & Placements' },
        { id: 'ranking', label: 'Ranking' },
        { id: 'scholarship', label: 'Scholarship' },
        { id: 'application', label: 'Application Info' }
    ];
    selectTab(id: string) {
        this.tabChange.emit(id);
    }
}
